import { type NodeProps, Position } from '@xyflow/react';
import NodeHandler from 'automations/components/NodeHandler';
import { EdgeType } from 'automations/data/edgeTypes';
import { useAutomationDispatch } from 'automations/hooks/useAutomationDispatch';
import { childrenNodesSelector } from 'automations/selectors/reactFlow';
import { addNodeWithPosition } from 'automations/store/reactFlowSlice';
import { type IfElseNodeType } from 'automations/types/nodeTypes';
import { generateNewNodePayload } from 'automations/utils/node';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import styles from './IfElseNodeAdditionalContent.module.scss';

export default function AdditionalHandlers({
  node,
}: {
  node: NodeProps<IfElseNodeType>;
}) {
  const dispatch = useAutomationDispatch();
  const { id } = node;

  const childerenNodes = useSelector(childrenNodesSelector(id));

  const ifChildPresent = childerenNodes.find((childNode) => childNode.data.executionOrder === 1);
  const elseChildPresent = childerenNodes.find((childNode) => childNode.data.executionOrder === 2);

  const handleAddNode = useCallback((sourceHandle: string) => {
    const newNode = generateNewNodePayload({
      data: {
        executionOrder: sourceHandle === 'if' ? 1 : 2,
      },
    });
    dispatch(addNodeWithPosition({
      newNode,
      sourceNodeId: id,
      edgeConfig: {
        sourceHandle,
        type: sourceHandle === 'if' ? EdgeType.if : EdgeType.else,
      },
    }));
  }, [dispatch, id]);

  return (
    <>
      <NodeHandler
        type="source"
        position={Position.Bottom}
        onClick={ifChildPresent ? undefined : () => handleAddNode('if')}
        id="if"
        className={styles.ifHandler}
        nodeId={id}
      />
      <NodeHandler
        type="source"
        position={Position.Bottom}
        onClick={elseChildPresent ? undefined : () => handleAddNode('else')}
        id="else"
        className={styles.elseHandler}
        nodeId={id}
      />
    </>
  );
}
